<template>
	<AppTextTooltip tooltipText="This step can't be edited">
		<FlowTreeVirtualBlock v-on="$listeners" v-bind="$attrs" :blockData="blockData" :appData="appData" />
	</AppTextTooltip>
</template>

<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import FlowTreeVirtualBlock from './FlowTreeVirtualBlock.vue';
import { getService } from '@/store/modules/apps/getters';
import PlacementService from '@/utils/placement-service';
export default {
	name: 'FlowTreeVirtualBlockDataProvider',
	props: { placement: { type: Object } },
	components: { FlowTreeVirtualBlock },
	computed: {
		...mapGettersShorthand({ getService }),
		appData() {
			return this.getService(this.placement.service);
		},
		blockData() {
			return {
				service: 'some-value' /* here so FlowTreeVirtualBlock will think we have service applied */,
				node_title: PlacementService.getContextualVirtualNodeTitle(this.appData),
			};
		},
	},
};
</script>

<style lang="scss" scoped></style>
